"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiContext = void 0;

var _react = require("react");

/**
 * Контекст с параметрами вызова виджета
 */
var apiContext = /*#__PURE__*/(0, _react.createContext)({
  api: undefined
});
exports.apiContext = apiContext;